<div class="image-frame js-image-frame">
    @if (src) {
        <figure class="image-frame__figure">
            <img class="image-frame__img" [src]="src | trustResource" />
        </figure>
    } @else {
        <div class="image-frame__empty">
            <div class="empty-image text--center">
                <skl-icon name="image" class="empty-image__icon"></skl-icon>
                <div class="empty-image__text">{{ emptyImageText }}</div>
            </div>
        </div>
    }
</div>
